export default "__VITE_ASSET__ed87b6bd__"